// config/apiConfig.js
const API_CONFIG = {
  BASE_URL:
    process.env.REACT_APP_API_BASE_URL_PRODUCTION
 ||
    "https://dev-backend.3d-medico.com",

  LOCAL_BASE_URL:
    process.env.REACT_APP_API_BASE_URL || "http://localhost:3001",

  PYTHON_BASE_URL:
    process.env.REACT_APP_PYTHON_BASE_URL_PRODUCTION || "https://demopy.3d-medico.com/", // Assuming this is the production URL, need to verify or use a placeholder if unknown. The user mentioned https://v3s-api-backend.3d-medico.com in previous summary as a hardcoded URL.
  LOCAL_PYTHON_BASE_URL:
    process.env.REACT_APP_PYTHON_BASE_URL || "http://localhost:8000",

  ENDPOINTS: {
    LOGIN: "/api/auth/login",
    LOGOUT: "/api/auth/logout",
    ADMIN_LOGIN: "/api/auth/admin-login",
    REGISTER: "/api/register-mail",
    BILLING_ADDRESS: "/api/payment/update-billing-address",
    UPLOAD_SCAN: "/api/upload",
    USER: "/api/auth/user",
    USER_ROLES: "/api/user/userRoles",

    // ===== Added Misc.js API Endpoints =====
    PROCESSING_STATUS: "/api/misc/status",
    PREVIEW_FOLDER_CONTENT: "/api/misc/downloadFolderContent",
    PREVIEW_IMAGE: "/api/misc/getPreviewImage",
    APPROVAL_DECISION: "/api/misc/approval",

    // ===== Added Upload.js API Endpoints =====
    UPLOAD_PROCESSING_STATUS: "/api/upload/processing-status",
    CHECK_MODEL_FILES: "/api/upload/checkModelFiles",
    DOWNLOAD_ATTEMPT: "/api/upload/downloadAttempt",
  },
};

export const buildUrl = (base, endpoint) => {
  const cleanBase = base.replace(/\/+$/, "");
  const cleanEndpoint = endpoint.replace(/^\/+/, "");
  return `${cleanBase}/${cleanEndpoint}`;
};

export const getBaseUrl = (endpointKey) => {
  // Check if running locally
  const isLocal =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  return isLocal ? API_CONFIG.LOCAL_BASE_URL : API_CONFIG.BASE_URL;
};

export const getPythonBaseUrl = () => {
  const isLocal =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  return isLocal ? API_CONFIG.LOCAL_PYTHON_BASE_URL : API_CONFIG.PYTHON_BASE_URL;
};

export default API_CONFIG;
